import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/ubicaciones`;

export async function getDepartamentos() {
  const response = await axios.get(`${baseUrl}/departamentos`);
  return response.data;
}

export async function getMunicipios(departamentoId) {
  if (!departamentoId || isNaN(departamentoId)) {
    return { success: true, data: [] };
  }
  
  const response = await axios.get(`${baseUrl}/municipios/${departamentoId}`);
  return response.data;
}